var _circle, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCheckmarkIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#68DE88"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5558 8.27727C15.0309 7.59866 15.9662 7.43374 16.6448 7.90891C17.3235 8.38407 17.4884 9.31939 17.0132 9.998L12.9982 15.7321C12.6816 16.1842 12.1608 16.4083 11.6478 16.367C11.2317 16.4349 10.7896 16.328 10.4414 16.0357L7.37719 13.4646C6.74258 12.9321 6.6598 11.9859 7.19231 11.3513C7.72481 10.7167 8.67094 10.6339 9.30555 11.1664L11.3384 12.8722L14.5558 8.27727Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmarkIcon);
export default __webpack_public_path__ + "static/media/checkmark-icon.171e303f.svg";
export { ForwardRef as ReactComponent };